// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2Pqyr","footer":"ChangeClinic_footer__1Kwy7"};